import { TableCell, TableRow } from "@mui/material";

function NormalRow(props) {
  const { request, columns, color } = props;

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          return (
            <TableCell
              component="th"
              scope="row"
              key={`${column.columnName}-${index}`}
            >
              {/* {column.dbName.split("/").length === 2
                ? request[column.dbName.split("/")[0]][
                    column.dbName.split("/")[1]
                  ]
                : request[column.dbName] == null
                ? ""
                : column.columnName === 'Estado' ? mapStatus(request[column.dbName]) : request[column.dbName]} */}
              {"hola"}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
}

export default NormalRow;
